import getDialogByType from './get-dialog-by-type';

export default {
  getDialogByType,
};
